import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrCardComponent } from './pr-card/pr-card.component';
import { PrCardsComponent } from './pr-cards/pr-cards.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrLoaderModule } from '../pr-loader/pr-loader.module';
import { PrCardCenterComponent } from './pr-card-center/pr-card-center.component';
import { PrCardsCenterComponent } from './pr-cards-center/pr-cards-center.component';
import { PrRiskLevelLadderModule } from '../pr-risk-level-ladder/pr-risk-level-ladder.module';

@NgModule({
  declarations: [
    PrCardComponent,
    PrCardsComponent,
    PrCardCenterComponent,
    PrCardsCenterComponent,
  ],
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    PrIconModule,
    PrLoaderModule,
    PrRiskLevelLadderModule,
  ],
  exports: [
    PrCardComponent,
    PrCardsComponent,
    PrCardCenterComponent,
    PrCardsCenterComponent,
  ],
})
export class PrCardModule {}
